import { useBreakpointValue } from '@chakra-ui/react';
import { createContext } from 'react';

export const MatchBreakpointsContext = createContext<BreakpointChecks>({
  isMobile: false,
  isTablet: false,
  isDesktop: false,
});

export type BreakpointChecks = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

export function useResponsive(): BreakpointChecks {
  const isMobile = useBreakpointValue({ base: true, sm: false }) || false;
  const isTablet = useBreakpointValue({ sm: true, md: false }) || false;
  const isDesktop = useBreakpointValue({ md: true }) || false;

  return { isMobile, isTablet, isDesktop };
}
